import { getMonth } from 'date-fns';

export const isLastMinute = (application: any): boolean => {
    const currentMonth = new Date().getMonth();
    const appMonth = getMonth(new Date(application.startdate));
    const calcMonth = appMonth - currentMonth;
    // check if applying for the same month, the month after today's month and Dec to Jan apps
    if (calcMonth === 0 || calcMonth === 1 || calcMonth === 11) {
        // check if the apps are on the same year
        if (new Date().getFullYear() === application.startyear) {
            return true;
        } else {
            return false;
        }
    } else {
        return false;
    }
};
